/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_SuccessInputs */

const en_dispatch_success = /** @type {(inputs: Dispatch_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task dispatched`)
};

const fr_dispatch_success = /** @type {(inputs: Dispatch_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche envoyée`)
};

const ms_sg2_dispatch_success = /** @type {(inputs: Dispatch_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tugasan dihantar`)
};

/**
* | output |
* | --- |
* | "Task dispatched" |
*
* @param {Dispatch_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_success = /** @type {((inputs?: Dispatch_SuccessInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_SuccessInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_success(inputs)
	if (locale === "fr") return fr_dispatch_success(inputs)
	return ms_sg2_dispatch_success(inputs)
});